<ion-content [fullscreen]="true" class="page-content" color="light">
  <generic-table style="width: 100%; height: 100%" [tableColumns]="tableColumns" [data]="tableData"
    [config]="tableConfigParams" [isLoading]="isDataLoading" [totalItems]="totalDevices" [pageIndex]="currentPage - 1"
    [pageSize]="currentLimit" (onOptionAction)="onOptionAction($event)" (onCtaAction)="onCtaAction($event)"
    (onPaginatorChange)="handlePagination($event)" (onFiltersChange)="onFiltersChange()"
    (onSearchChange)="onSearchChange($event)"></generic-table>
</ion-content>
